<script>
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import axios from "axios";
    import {store} from "@/store/store";
    import {mapActions} from "vuex";
    export default {
    data() {
        return {
            cloudinary: {
                name: "lms-edc",
            },
            dropzoneOptions: {
                url: "https://api.lms.com/upload",
                thumbnailWidth: 100,
                thumbnailHeight: 100,
                maxFilesize: 2,
                uploadMultiple: false,
                addRemoveLinks: true,
                autoProcessQueue: false,
                headers: {
                    "My-Awesome-Header": "header value"
                },
            },
        };
    },
    methods: {
        ...mapActions([
            "learnerCourseRepay",
            "learnerProgramPay",

        ]),
        async uploadFile(file) {
            const formData = new FormData();
            formData.append("asset_file", file);
            formData.append("upload_preset", "xqsyhkma");
            const baseUrl = process.env.VUE_APP_API;
            // const endpoint = `https://api.cloudinary.com/v1_1/${this.cloudinary.name}/image/upload`;
            const endpoint = `${baseUrl}/tenant/asset/upload-to-bucket`;
            try {
                const res = await axios.post(endpoint, formData, {
                    headers: {
                        "content-type": "multipart/form-data",
                        Authorization: `Bearer ${store.state.auth.token}`,
                    },
                });

                if (res.status === 200 || res.status === 201) {
                    return res.data.data.file_url;
                }
            } catch (e) {
                //console.log(e);
            }
        },
        getStrippedText(input) {
            return input.replace(/(<([^>]+)>)/gi, "");
        },
        extractContent: (s, space) => {
            let span = document.createElement("span");
            span.innerHTML = s;
            if (space) {
                let children = span.querySelectorAll("*");
                for (let i = 0; i < children.length; i++) {
                    if (children[i].textContent) children[i].textContent += " ";
                    else children[i].innerText += " ";
                }
            }
            return [span.textContent || span.innerText]
                .toString()
                .replace(/ +/g, " ");
        },
        nairaToKobo(amount) {
            return (amount * 100).toFixed(0);
        },
        async verifycoursePayment(trx_ref, amount, course) {
            let res = await this.learnerCourseRepay({
                amount: parseFloat(amount),
                course: course,
                txn_ref: trx_ref !== null ?
                    trx_ref :
                    Math.random()
                    .toString(36)
                    .substring(7),
            });

            if (res.status === 201 || res.status === 200) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Transaction Successful",
                });
                this.$router.push({
                    name: 'learner-single-course',
                    params: {
                        id: course.id
                    }
                })
            } else {}
        },
        async verifyProgramPayment(trx_ref, amount, course) {
            let res = await this.learnerProgramPay({
                amount: parseFloat(amount),
                course: course,
                txn_ref: trx_ref !== null ?
                    trx_ref :
                    Math.random()
                    .toString(36)
                    .substring(7),
            });

            if (res.status === 201 || res.status === 200) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Transaction Successful",
                });
                this.$router.push({
                    name: 'learner-single-course',
                    params: {
                        id: course.id
                    }
                })

            } else {}
        },
        processPayment({
            user,
            course
        }) {
            let that = this;
            let amount = 0;
            if (course.course_subscription_type === 'specify' && course.payment_type === 'paid') {
                amount = course.price
            } else if (parseInt(course.price) === 0) {
                return that.verifycoursePayment(null, amount, course);
            } else if (course.course_subscription_type === 'inherit' && course.payment_type === 'paid' && course.subscription_type === 'bulk') {
                amount = course.subscription.subscription_cost
            } else if (parseInt(course.subscription.subscription_cost) === 0) {
                return that.verifyProgramPayment(null, amount, course);

            }
            let handler = PaystackPop.setup({
                key: "pk_live_921e367ae8e08ed0badd3b7081af68c7c0c49fdb",
                email: user.email,
                amount: this.nairaToKobo(parseFloat(amount)),
                channels: ["card", "bank", "ussd"],
                metadata: {
                    custom_fields: [{
                        user_name: "User",
                        variable_name: user.phone_number,
                    }, ],
                },
                callback: function (response) {
                    that.ref = response.reference;
                    if (course.course_subscription_type === 'specify') {
                        that.verifycoursePayment(response.reference, amount, course);

                    }
                    if (course.course_subscription_type === 'inherit') {

                        that.verifyProgramPayment(response.reference, amount, course);

                    }
                },
                onClose: function () {
                    //console.log("window closed");
                },
            });

            handler.openIframe();
        },


    },
    components: {
        vueDropzone: vue2Dropzone,
    },
    mounted() {
        const payPopup = document.createElement("script");
        payPopup.setAttribute("src", "https://js.paystack.co/v2/inline.js");
        payPopup.async = true;
        document.head.appendChild(payPopup);
    }
};
</script>
